import { mainTheme } from '../../themes/mainTheme';

export const ratingVariants = <const> [
	'neutral',
	'success',
	'info',
	'primaryDark',
	'warning',
	'danger',
];

export type RatingVariant = typeof ratingVariants[number];

// Each variant pairs a light text/stroke with the dark fill of the same role, as Label does.
const neutral = {
	color: mainTheme.text.tertiary,
	borderColor: mainTheme.border.interactive,
	backgroundColor: mainTheme.fill.dimmed,
};

export const RatingVariantCssDefinition = {
	neutral,
	primaryDark: {
		color: mainTheme.text.brand,
		borderColor: mainTheme.border.brand,
		backgroundColor: mainTheme.fill.success,
	},
	info: neutral,
	success: {
		color: mainTheme.text.success,
		borderColor: mainTheme.border.successSecondary,
		backgroundColor: mainTheme.fill.success,
	},
	warning: {
		color: mainTheme.text.warning,
		borderColor: mainTheme.border.caution,
		backgroundColor: mainTheme.fill.warning,
	},
	danger: {
		color: mainTheme.text.danger,
		borderColor: mainTheme.border.danger,
		backgroundColor: mainTheme.fill.danger,
	},
};
